<template>
  <div class="mb-2">
    <label :for="id" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{{ label }}</label>
    <div v-if="type === 'file'" class="relative">
      <!-- Hidden file input -->
      <input
        :id="id"
        ref="fileInput"
        type="file"
        class="absolute inset-0 opacity-0 cursor-pointer"
        :required="required"
        :disabled="disabled"
        @change="onInputChange"
      />
      <!-- File input UI -->
      <div
        class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5 flex items-center justify-between dark:bg-gray-700 dark:border-gray-600 dark:text-white"
      >
        <span v-if="fileName" class="truncate">{{ fileName }}</span>
        <span v-else class="text-gray-400 dark:text-gray-500">No file chosen</span>
        <button
          type="button"
          @click="triggerFileInput"
          class="ml-2 px-3 py-1 text-sm font-medium text-white bg-blue-500 rounded hover:bg-blue-600 focus:outline-none"
        >
          Choose File
        </button>
      </div>
    </div>
    <!-- Other input types -->
    <input
      v-else
      :id="id"
      :type="type"
      :class="[inputClasses, 'shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500']"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :value="modelValue"
      :aria-label="label"
      :aria-describedby="validationMessage ? `${id}-error` : null"
      @input="onInputChange"
    />
    <!-- Validation message -->
    <p v-if="validationMessage" :id="`${id}-error`" class="mt-1 text-sm text-red-600 dark:text-red-500">
      {{ validationMessage }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: [String, File],
    label: { type: String, default: '' },
    id: { type: String, default: '' },
    type: { type: String, default: 'text' },
    inputClasses: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    validationMessage: { type: String, default: '' },
  },
  data() {
    return {
      fileName: '', // Track the name of the selected file
    };
  },
  methods: {
    onInputChange(event) {
      if (this.type === 'file') {
        const file = event.target.files[0] || null;
        this.fileName = file ? file.name : 'No file chosen';
        this.$emit('update:modelValue', file); // Emit the file object
      } else {
        this.$emit('update:modelValue', event.target.value);
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click(); // Programmatically trigger the file input
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  opacity: 0;
  position: absolute;
  inset: 0;
  cursor: pointer;
}
</style>